import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { bindActionCreators } from 'redux'
import {useTranslation} from 'react-i18next';
import helpers from '../../../Utils/helpers'
import CollaborationsList from '../../../Components/Customer/CollaborationsList'
import BadgeCounter from "../../../Components/BadgeCounter";
import {CardContainer, DefaultCard} from "../../../Components/Card/Card";
import customerRoutes from "../../../Constants/Customer/customerRoutes";
import comActions from "../../../Actions/commonActions";
import custActions from "../../../Actions/customerActions";
import CollaborationDiagrams from "../../../Components/Customer/Collaborations/CollaborationDiagrams";
import useSortingAndFiltering from "../../../Hooks/useSortingAndFiltering";

function CollaborationsContainer({}) {
    const customer = useSelector(state => state.CustomerReducer.customer);
    const collaborations = useSelector(state => state.CustomerReducer.collaborations);
    const grouped = useSelector(state => state.CustomerReducer.collaborationsGrouped);
    const dispatch = useDispatch();
    const commonActions = bindActionCreators(comActions, dispatch);
    const customerActions = bindActionCreators(custActions, dispatch);
    const isLoading = useSelector((state) => state.CommonReducer.dataLoading.collaborations);
    
    const { t } = useTranslation();
    const [searchInput, setSearchInput] = useState("");
    const {filteredAndSortedList, sortKey, sortOrder, handleSortChange} = useSortingAndFiltering({
        list: collaborations,
        searchText: searchInput,
        searchableKeys: ["name", "customerNumber", "organizationNumber", "consultantName", "consultantNumber", "invoiceParty", "moduleName", "product"],
    })
    
    useEffect(() => {
        let controller = new AbortController();
        customerActions.getCollaborations(customer.vonCustomer.id, customer.vonCustomer.isAllowedToInvite, controller);
        
        return () => {
            controller.abort();
        }

    }, []);

    const onChange = (event) => {
        setSearchInput(event.target.value);
    }

    const groupCollaborations = (collaborations) => {
        return collaborations?.reduce((result, collaboration) => {
            const product = collaboration.product || 'n/a'
            result[product] = result[product] || [];
            result[product].push(collaboration);

            return result;
        }, Object.create(null));
    }

    const groupModules = (products) => {
        let result = []

        products.map((collab, index) => {
            if (result.some(result => result.key === collab.moduleName)) {
                let index = result.findIndex(key => key.key === collab.moduleName);
                result[index].value++
            }
            else
                result.push({ key: collab.moduleName, value: 1 });
        });

        return result
    }

    const navigateToCustomer = (customerNumber) => {
        window.open(customerRoutes.customer(customerNumber));
    }

    const refreshCollaborations = () => {
        let controller = new AbortController();
        customerActions.getCollaborations(customer.vonCustomer.id, customer.vonCustomer.isAllowedToInvite, controller);
    }

    const groupedCollaborations = groupCollaborations(collaborations);
    const serviceNames = [...new Set(grouped?.map(x => x.serviceName))]
    const showConsultant = filteredAndSortedList?.findIndex(key => key.clientId === customer.vonCustomer.id) >= 0;
    
    return (<CardContainer>
            <DefaultCard title={t('collaboration.header')} isLoading={isLoading}>
                <fieldset>
                    <input placeholder={t('collaborationscontainer.searchfield')} className="form-control" type="text" autoFocus value={searchInput} onChange={onChange} />
                </fieldset>
            
                <div className="group-list">
                    {groupedCollaborations && Object.keys(groupedCollaborations)?.sort().map((product) => {

                        return <details key={product} className="collapse-list">
                            <summary className="collapse-list-header">
                                <div className="collapse-list-title d-flex align-items-center">
                                    <span className="caret ml-0 mr-8"></span>
                                    <span>{product}</span>
                                    <span className="ml-8 d-flex align-items-center">
                                        <BadgeCounter badgeNumber={groupedCollaborations[product].length} />
                                    </span>
                                </div>
                            </summary>
                            <div className="collapse-list-content">
                                {groupModules(groupedCollaborations[product]).map((collabCount) => {

                                    return <details key={collabCount.key || product} className="collapse-list">
                                            <summary className="collapse-list-header">
                                                <div className="collapse-list-title">
                                                    <span className="caret ml-0 mr-8"></span>
                                                    <span>{!!collabCount.key ? collabCount.key : product}</span>
                                                    <span className="ml-8 d-flex align-items-center">
                                                        <BadgeCounter badgeNumber={collabCount.value} />
                                                    </span>
                                                </div>
                                            </summary>
                                            <div className="collapse-list-content">

                                                <table className="table table-stripe table-condensed">
                                                    <thead>
                                                    <tr>
                                                        {showConsultant ?
                                                            <>
                                                                <th>{t('collaboration.consultantnumber')}</th>
                                                                <th>{t('collaboration.consultantname')}</th>
                                                            </> :
                                                            <>
                                                                <th>{t('common.organizationnumber')}</th>
                                                                <th>{t('collaboration.customernumber')}</th>
                                                                <th>{t('collaboration.customername')}</th>
                                                            </>
                                                        }
                                                        <th>{t('collaboration.noninteractive')}</th>
                                                        <th>{t('collaboration.invoicereceiver')}</th>
                                                        <th>{t('created')}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
            
                                                    {groupedCollaborations[product].filter(t => t.moduleName === collabCount.key).map((collab, index) => {
                                                        return <tr key={index}>
                                                            {showConsultant ?
                                                                <>
                                                                    <td><a onClick={() => navigateToCustomer(collab.consultantNumber)}>{collab.consultantNumber}</a></td>
                                                                    <td>{collab.consultantName} </td>
                                                                </> :
                                                                <>
                                                                    <td>{collab.customerNumber ? <a onClick={() => navigateToCustomer(collab.customerNumber)}>{collab.organizationNumber}</a> : collab.organizationNumber}</td>
                                                                    <td><a onClick={() => navigateToCustomer(collab.customerNumber)}>{collab.customerNumber}</a></td>
                                                                    <td>{collab.name} </td>
                                                                </>
                                                            }
                                                            <td>{collab.isNonInteractive ? t('common.yes') : t('common.no')}</td>
                                                            <td>{collab.invoiceParty}</td>
                                                            <td>{helpers.formatDate(collab.created)}</td>
                                                        </tr>
            
                                                    })}
                                                    </tbody>
                                                </table>
            
                                            </div>
                                        </details>
                                })}
                            </div>
                        </details>
                    })}
                </div>
                {filteredAndSortedList && <CollaborationsList collaborations={filteredAndSortedList} handleSortChange={handleSortChange} sortOrder={sortOrder} sortKey={sortKey} listOfServiceNames={serviceNames}
                                                               showConsultant={showConsultant}
                                                               customerActions={customerActions} refreshCollaborations={refreshCollaborations}/>}
            </DefaultCard>
            <CollaborationDiagrams collaborations={grouped} serviceNames={serviceNames} isLoading={isLoading}/>
        </CardContainer>
    );
}

export default CollaborationsContainer;